import { render, staticRenderFns } from "./appointmentNext.vue?vue&type=template&id=50332e00&scoped=true&"
import script from "./appointmentNext.vue?vue&type=script&lang=js&"
export * from "./appointmentNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50332e00",
  null
  
)

export default component.exports